// extracted by mini-css-extract-plugin
export default {"listWrapper":"nKKPa","list":"i6gFr","listElement":"plVma","image":"hKIbc"};